import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  CardContent,
  IconButton,
  TextField,
  Button,
  styled,
  InputAdornment,
  FormControl,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";

const StyledCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  maxWidth: "600px",
  width: "77%", // عرض 50% من الشاشة
  margin: "auto",
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function EditUserModal({ userId, onClose, onSubmit }) {
  const [userData, setUserData] = useState({
    userName: "",
    password: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}User/Find/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserData({
          userName: response.data.userName,
          password: localStorage.getItem("password"), // كلمة المرور تبقى فارغة في حال لم يرغب المستخدم بتعديلها
        });
      } catch (error) {
        // console.error("Error fetching user data:", error);
        if (error.response && error.response.status === 401) {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          try {
            const response = await axios.get(
              `${API_BASE_URL}User/Find/${userId}`,
              {
                headers: {
                  Authorization: `Bearer ${newToken}`,
                },
              },
            );
            setUserData({
              userName: response.data.userName,
              password: localStorage.getItem("password"), // كلمة المرور تبقى فارغة في حال لم يرغب المستخدم بتعديلها
            });
          } catch (retryError) {
            // console.error("Retry failed:", retryError);
            // return <navigate to="/" />;
          }
        } else {
          alert("Error:", error);
        }
      }
    };

    fetchUserData();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    // تحقق من الحقول المطلوبة
    if (!userData.userName) {
      alert("يرجى تعبئة جميع الحقول المطلوبة");
      return;
    }

    // إذا كانت كلمة المرور الجديدة فارغة، استخدم كلمة المرور القديمة
    let passwordToSend =
      userData.password === ""
        ? localStorage.getItem("password")
        : userData.password;

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}User/Find/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      // console.error("Error fetching the old password:", error);
      // alert("حدث خطأ أثناء جلب كلمة المرور القديمة");
      if (error.response && error.response.status === 401) {
        const newToken = await refreshTokenIfNeeded();

        if (!newToken) {
          return navigate("/", { replace: true });
        }
        try {
          const response = await axios.get(
            `${API_BASE_URL}User/Find/${userId}`,
            {
              headers: {
                Authorization: `Bearer ${newToken}`,
              },
            },
          );
        } catch (retryError) {}
      } else {
        // alert("Error:", error);
      }

      return;
    }

    const formData = new FormData();
    formData.append("userName", userData.userName);
    formData.append("password", passwordToSend); // إرسال كلمة المرور القديمة أو الجديدة

    try {
      const token = localStorage.getItem("token");
      await axios.put(`${API_BASE_URL}User/Update/${userId}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      alert("تم تعديل المشرف بنجاح");
      onSubmit(); // تحديث البيانات
      onClose(); // إغلاق المودال بعد التحديث
    } catch (error) {
      // console.error("Error updating user:", error);
      // alert("حدث خطأ أثناء تعديل المشرف");
      if (error.response && error.response.status === 401) {
        const newToken = await refreshTokenIfNeeded();

        if (!newToken) {
          return navigate("/", { replace: true });
        }

        try {
          await axios.put(`${API_BASE_URL}User/Update/${userId}`, formData, {
            headers: {
              Authorization: `Bearer ${newToken}`,
              "Content-Type": "multipart/form-data",
            },
          });
          alert("تم تعديل المشرف بنجاح");
          onSubmit(); // تحديث البيانات
          onClose(); // إغلاق المودال بعد التحديث
        } catch (retryError) {
          // console.error("Retry failed:", retryError);
          // return <navigate to="/" />;
          alert("ليس لديك صلاحيات");
          onClose();
        }
      } else {
        alert("ليس لديك صلاحيات");
        onClose();
      }
    }
  };

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <AccountCircleIcon sx={{ fontSize: 80, color: "gray" }} />
          </Box>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>
          <CardContent sx={{ textAlign: "right", mt: 2 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "3%",
                fontFamily: "'Changa', sans-serif",
              }}
            >
              <h3>تعديل مشرف</h3>
            </div>

            {/* حقل اسم المشرف */}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
              <TextField
                placeholder="اسم المشرف"
                value={userData.userName}
                name="username"
                onChange={handleChange}
                variant="outlined"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0064b7",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircleIcon sx={{ color: "green" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            {/* حقل كلمة المرور */}
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
              <TextField
                placeholder="**************************"
                type="password"
                value={userData.password}
                name="password"
                onChange={handleChange}
                variant="outlined"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#5b5b5c",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0064b7",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#3c3c3c" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>

            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                حفظ التعديلات
              </Button>
            </Box>
          </CardContent>
        </StyledCard>
      </Box>
    </Modal>
  );
}

export default EditUserModal;
